import type { ThemeOptions } from '@mui/material/styles';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Fragment, useMemo } from 'react';
import { dataDisplayCustomizations } from './customizations/dataDisplay';
import { dialogCustomizations } from './customizations/dialog';
import { feedbackCustomizations } from './customizations/feedback';
import { inputsCustomizations } from './customizations/inputs';
import { navigationCustomizations } from './customizations/navigation';
import { surfacesCustomizations } from './customizations/surfaces';
import { colorSchemes, shadows, shape, typography } from './primitives';

interface AppThemeProps {
  children: React.ReactNode;
  disableCustomTheme?: boolean;
  disableCustomInputs?: boolean;
  themeComponents?: ThemeOptions['components'];
}

const AppTheme = (props: AppThemeProps) => {
  const { children, disableCustomTheme, themeComponents, disableCustomInputs } = props;

  const theme = useMemo(() => {
    return disableCustomTheme
      ? {}
      : createTheme({
        cssVariables: {
          colorSchemeSelector: 'data-mui-color-scheme',
          cssVarPrefix: 'template',
        },
        typography,
        shadows,
        shape,
        palette: colorSchemes,
        components: {
          ...(disableCustomInputs == true ? {} : inputsCustomizations),
          ...dataDisplayCustomizations,
          ...feedbackCustomizations,
          ...navigationCustomizations,
          ...surfacesCustomizations,
          ...themeComponents,
          ...dialogCustomizations,
        },
      });
  }, [disableCustomTheme, disableCustomInputs, themeComponents]);

  if (disableCustomTheme) {
    return <Fragment>{children}</Fragment>;
  }

  return (
    <ThemeProvider theme={theme} disableTransitionOnChange>
      {children}
    </ThemeProvider>
  );
};

export default AppTheme;
